import compact from 'lodash/compact';

import { TableColumn } from './types';

export function resolveVisibleColumns<T, K extends string>(
  columns: TableColumn<T, K>[],
  order?: K[],
): TableColumn<T, K>[] {
  if (!order) return columns;

  return compact(order.map(key => columns.find(column => column.key === key)));
}
